jQuery($ => {
    class PanelMenu {
      constructor(element) {
        this._             = element;
        this._element      = $(element);
        this._panel        = this._element.find('.m-panel-menu__panel');
        this._menu         = this._element.find('.m-panel-menu__menu');
        this._option       = this._element.find('.m-menu-option');
        this._headerButton = this._element.find('.m-menu-header__button');

        this._controlledby = this._element.data('controlledby');
        this._controller   = $(`#${this._controlledby}`);

        this._activeOption = this._element.find('.m-menu-option--active');
        this._activePanel  = this._element.find('.m-panel-menu__panel--open');

        this.focusable = 'button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
  
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'init', this );
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        this._menu.on('control', this.handleMenuControl);
        this._controller.on('control', this.handleMenuControl);
        this._option.on('keydown', this.handleOptionKeydown);
        this._controller.find('.m-menu-option').on('keydown', this.handleOptionKeydown);
        this._panel.find(this.focusable).on('keydown', this.handlePanelKeydown);
        this._headerButton.on('keydown', this.handleHeaderButtonKeydown);
        this._menu.on('keyToEdge', this.handleMenuKeyToEdge);
        this._element.on('reset', this.resetAll);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Open Panel
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      openPanel = panel => {
        const $panel = $(panel);

        if (!$panel.hasClass('m-panel-menu__panel--open')) {
          if ($panel.hasClass('m-panel-menu__panel--1')) {
            this._panel.filter('.m-panel-menu__panel--2.m-panel-menu__panel--open').each((_,panel) => this.closePanel(panel));
          }
  
          $panel.addClass('m-panel-menu__panel--open');
        }

        $panel.find(this.focusable).first().focus();

        this._element.trigger('change');
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Close Panel
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      closePanel = panel => {
        const $panel = $(panel);
        const $option = $panel.find('.m-menu-option');

        $option.removeClass('m-menu-option--active');
        $panel.removeClass('m-panel-menu__panel--open');

        this._element.trigger('change');
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Reset Option
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      resetOption = $option => {
        const $panel = $(`#${$option.attr('aria-controls')}`)

        $option.removeClass('m-menu-option--active');
        $option.attr('aria-expanded', 'false');
        this.closePanel($panel);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Reset All Options
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      resetAll = () => {
        // Iterate over each panel and close it if it's not the active one
        this._panel.each((_, panel) => {
          const $panel = $(panel);
      
          // Skip closing the active panel
          if (this._activePanel.length && this._activePanel[0] === $panel[0]) return;

          // If the panel is already closed, skip further action
          if (!$panel.hasClass('m-panel-menu__panel--open')) return;
          
          $panel.removeClass('m-panel-menu__panel--open');
        });
      
        // Iterate over each option and deactivate it if it's not the active one
        this._option.each((_, option) => {
          const $option = $(option);
      
          // Skip deactivating the active option
          if (this._activeOption.length && this._activeOption[0] === $option[0]) return;

          // If the option is already inactive, skip further action
          if (!$option.hasClass('m-menu-option--active')) return;
          
          $option.removeClass('m-menu-option--active');
          $option.attr('aria-expanded', 'false');
        });
      
        // Ensure the active panel and option retain their state after reset
        if (this._activePanel.length && !this._activePanel.hasClass('m-panel-menu__panel--open')) {
          this._activePanel.addClass('m-panel-menu__panel--open');
        }
        if (this._activeOption.length && !this._activeOption.hasClass('m-menu-option--active')) {
          this._activeOption.addClass('m-menu-option--active').attr('aria-expanded', 'true');
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Activate Option
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      activateOption = ($option, $panel = null) => {
        const $optionPanel = $panel || $(`#${$option.attr('aria-controls')}`);

        $option.addClass('m-menu-option--active');
        $option.attr('aria-expanded', 'true');
        this.openPanel($optionPanel);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Menu Control
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleMenuControl = (event, $panel, $option) => {
        const $other_options = $option.closest('.m-menu-options').find('.m-menu-options__option').not($option);
        $other_options.each((_,option) => this.resetOption($(option)));
        
        this.activateOption($option, $panel);


      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Option Keydown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleOptionKeydown = event => {
        const $option      = $(event.currentTarget);
        const $item        = $option.closest('.m-menu-options__item');
        const ariaControls = $option.attr('aria-controls');
        const $rightPanel  = ariaControls ? $(`#${ariaControls}`) : false;
        const $currentPanel = $option.closest('.m-panel-menu__panel');
        const $headerButton = $currentPanel.find('.m-menu-header__button');

        switch (event.key) {
          case 'Enter':
          case 'spacebar':
          case ' ':
          // case 'ArrowRight':
            if ($rightPanel) {
              event.preventDefault();
              this.handleMenuControl(event, $rightPanel, $option);
            }
            break;

          case 'ArrowUp':
            if ($item.is(':first-child') && $headerButton[0]) {
              event.preventDefault();
              $headerButton.focus();
            }
            break;

          case 'ArrowDown':
            if ($item.is(':last-child') && $headerButton[0]) {
              event.preventDefault();
              $headerButton.focus();
            }
            break;

          // case 'ArrowLeft':
          //   const $panel       = $(event.currentTarget).closest('.m-panel-menu__panel');
          //   const controlledby = $panel.attr('data-controlledby');
          //   const $controller  = $(`#${controlledby}`);

          //   if ($controller) {
          //     event.preventDefault();

          //     $controller.focus();
          //     $controller.removeClass('m-menu-option--active');
          //     this.closePanel($panel);
          //   }

          //   break;
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Panel Keydown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handlePanelKeydown = event => {
        const $panel       = $(event.currentTarget).closest('.m-panel-menu__panel');
        const controlledby = $panel.attr('data-controlledby');
        const $controller  = $(`#${controlledby}`);

        const $focusable = $panel.find(this.focusable);
        const $first     = $focusable.first();
        const $last      = $focusable.last();

        switch (event.key) {
          case 'Tab':
            if (
              ($(event.target).is($last) && !event.shiftKey) ||
              ($(event.target).is($first) && event.shiftKey)
            ) {
              event.preventDefault();

              if ($(event.target).is($last)) {
                $first.focus();
              } else {
                $last.focus();
              }
            }
            break;

          case 'Escape':
          case 'Esc':
            $controller.focus();

            if (
              !this._element.find('.m-panel-menu__panel--0')[0] &&
              $panel.hasClass('m-panel-menu__panel--1')
            ) return;

            $controller.removeClass('m-menu-option--active');
            this.closePanel($panel);

            break;
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Header Button Keydown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleHeaderButtonKeydown = event => {
        const $panel        = $(event.currentTarget).closest('.m-panel-menu__panel');
        const $panelOptions = $panel.find('.m-menu-option');
        const controlledby  = $panel.data('controlledby');
        const $controller   = $(`#${controlledby}`);

        switch (event.key) {
          case 'ArrowUp':
            event.preventDefault();
            $panelOptions.last().focus();
            break;

          case 'ArrowDown':
            event.preventDefault();
            $panelOptions.first().focus();
            break;

          case 'ArrowLeft':
            event.preventDefault();
            $controller.focus();
            break;
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Menu Key-To-Edge
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleMenuKeyToEdge = (event, direction, option) => {
        switch (direction) {
          case 'left':
            const $panel       = $(event.currentTarget).closest('.m-panel-menu__panel');
            const controlledby = $panel.data('controlledby');
            const $controller  = $(`#${controlledby}`);
            
            $controller.focus();
            break;

          case 'right':
            const $option = $(option);
            const controls = $option.attr('aria-controls');
            
            if (controls) {
              $option.trigger('click');
            }

            break;
        }
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.panel_menu = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].panel_menu = new PanelMenu(_[i], opt);
        else
          ret = _[i].panel_menu[opt].apply(_[i].panel_menu, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.m-panel-menu').panel_menu();
});